import React from 'react';
import ReactDOM from 'react-dom/client';

// Порядок підключення стилів має значення:
// 1) фірмова тема, 2) структурний CSS PrimeReact, 3) іконки та утиліти,
// 4) наші токени й базові стилі — вони йдуть останніми, щоб мати перевагу.
import './theme/rct-theme.css';
import 'primereact/resources/primereact.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import './theme/tokens.css';
import './theme/app.css';

import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
